/**
 * getPrefix out what prefix our URL is at, given an expected path.
 * For example, if we expect to be at /js/test.js, prefixer will return '/'
 * If we are at /prefix/js/test.js, then prefixer will return '/prefix/'
 * You don't have to specify the last element exactly (ie test.js), it
 * is simply concerned with the number of elements.
 * It returns { Prefix: '', Origin: '' }
 */
export function getPrefix(script, expectedPath) {
	const url = new URL(script.src);
	// I know that our prefix will end in /js/all.*
	const pathParts = url.pathname.split(`/`);
	const prefix = pathParts.toSpliced(pathParts.length-expectedPath.split(`/`).length+1).join(`/`) + "/";
	return {
		'Prefix' : prefix,
		'Origin' : url.origin
	}
}